import { useRef } from 'react';

// 터치로 옆으로 밀어서(스와이프) 슬라이드를 넘기기 위한 핸들러
// - 옆으로 50px 이상, 그리고 세로보다 확실히 많이 움직였을 때만 넘김 (위아래 스크롤 중 실수로 넘어가지 않도록)
// - 두 손가락 터치(사진 확대/축소)는 무시
// 사용: <div {...useSwipe(다음으로, 이전으로)} style={SWIPE_STYLE}>
const MIN_DISTANCE = 50;

export const SWIPE_STYLE = { touchAction: 'pan-y pinch-zoom' };

const useSwipe = (onSwipeLeft, onSwipeRight) => {
  const start = useRef(null);

  const onTouchStart = (e) => {
    start.current = e.touches.length === 1
      ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
      : null;
  };

  const onTouchMove = (e) => {
    if (e.touches.length > 1) start.current = null;
  };

  const onTouchEnd = (e) => {
    if (!start.current) return;
    const touch = e.changedTouches[0];
    const dx = touch.clientX - start.current.x;
    const dy = touch.clientY - start.current.y;
    start.current = null;
    if (Math.abs(dx) < MIN_DISTANCE || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    if (dx < 0) onSwipeLeft();
    else onSwipeRight();
  };

  return { onTouchStart, onTouchMove, onTouchEnd };
};

export default useSwipe;
